import {useAutocomplete} from "@/app-autocomplete/providers/AutocompleteProvider.tsx";
import {useTranslations} from "@/hooks/useTranslations.ts";
import {type MouseEvent, type ReactNode, useEffect} from "react";

type AutocompleteModalProps = {
    children: ReactNode;
};

export function Modal({children}: AutocompleteModalProps) {
    const {isModalOpen, setIsModalOpen} = useAutocomplete();
    const tc = useTranslations();
    const handleModalClick = (e: MouseEvent<HTMLDivElement>) => {
        if (!(e.target as HTMLElement).closest(".aa-modal__box")) {
            setIsModalOpen(false);
        }
    };
    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isModalOpen]);
    return (
        <div aria-hidden={!isModalOpen} className={`aa-modal ${isModalOpen ? " is-active" : ""}`}
             onClick={(e) => handleModalClick(e)}>
            <div className="aa-modal__box">
                <div className={"aa-modal__content"}>
                    <button className="aa-modal__close" onClick={() => setIsModalOpen(false)} title={tc.close}>
                        <i className="icon icon-close" aria-hidden={true}></i>
                    </button>
                    {children}
                </div>
            </div>
        </div>
    );
}
